import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs } from 'antd';
import CustomerList from './index';
import StatisticalCustomer from './statisticalCustomer';
import CustomerSettings from './CustomerSettings';
import CustomerListSettings from './CustomerListSettings';
import { ALL_PERMISSION } from 'constants/permission';
import BasicTabs from 'components/BasicTabs';

const { TabPane } = Tabs;

const CustomerRegistration = () => {
  const { t: translation } = useTranslation();
  
  const listTab = [{
      key: "list",
      label :translation("listCustomers.tab.list"),
      permission: undefined,
      component: <CustomerList/>
    },
    // {
    //   key: "statistics",
    //   label :translation("listCustomers.tab.statistics"),
    //   permission: undefined,
    //   component: <StatisticalCustomer />
    // },
    {
      key: "settings",
      label :translation("listCustomers.tab.automation_takecare_customer"),
      permission: undefined,
      component: <CustomerListSettings />
    }
  ]

  return (
    <BasicTabs tabs={listTab} permissionConstant={ALL_PERMISSION.MANAGE_CUSTOMER.permissionTab} />
  );
};

export default CustomerRegistration;
